/* eslint-disable react/jsx-no-bind */
/* eslint-disable @scandipwa/scandipwa-guidelines/only-render-in-component */
/* eslint-disable react/no-unknown-property */
/**
 * Puma
 * @category    ScandiPWA
 * @author      Beshoy Samuel <info@scandiweb.com>
 * @copyright   Copyright (c) 2023 Scandiweb, Ltd (https://scandiweb.com)
 */

import {
    ProductWishlistButtonComponent as SourceProductWishlistButtonComponent
} from 'Component/ProductWishlistButton/ProductWishlistButton.component';
import WishlistHeartIcon from 'Component/WishlistHeartIcon';
import isMobile from 'Util/Mobile';

import './ProductCardWishlist.style';

/** @namespace Scandipwa/Component/ProductCardWishlist/Component */
export class ProductCardWishlistComponent extends SourceProductWishlistButtonComponent {
    renderButton() {
        const {
            isInWishlist, isDisabled, mix
        } = this.props;

        return (
            <button
              block="ProductWishlistButton"
              elem="Button"
              mods={ { isInWishlist, isDisabled } }
              mix={ { block: 'Button', mods: { isHollow: !isInWishlist }, mix } }
              title={ this.getTitle() }
              onClick={ (e) => this.onIconClick(e) }
              onTouchStart={ isMobile.iOS() ? (e) => this.onIconClick(e) : undefined }
            >
                <WishlistHeartIcon
                  mix={ { block: 'ProductWishlistButton', elem: 'ProductWishlistIcon' } }
                />
            </button>
        );
    }

    onIconClick(e) {
        const {
            product,
            quantity,
            isInWishlist,
            addToWishlist,
            removeFromWishlist
        } = this.props;

        e.stopPropagation();
        e.preventDefault();

        if (!isInWishlist) {
            return addToWishlist(product, quantity);
        }

        return removeFromWishlist(product, quantity);
    }

    renderContent() {
        return (
            <div block="ProductCardWishlist">
                { this.renderButton() }
            </div>
        );
    }
}

export default ProductCardWishlistComponent;
